// @flow

import type { StoreResourceDef } from 'app/core/types'

export const articleFlags: StoreResourceDef<> = {
  resourceType: 'articleFlags',
  relations: {
    flagInst: {
      type: 'hasOne',
      resourceType: 'flags',
      foreignKey: 'flag',
    },
  },
}
